// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jnkSQuOXOUbFGhdbs7fU{flex-direction:column;gap:20px;width:100%;display:flex;position:relative}.jnkSQuOXOUbFGhdbs7fU input{border:none;outline:none;padding:0;font-weight:500}.jnkSQuOXOUbFGhdbs7fU input::placeholder{color:var(--content-neutral-primary);font-family:Inter,sans-serif}.jnkSQuOXOUbFGhdbs7fU.yzY6fzNfpUpkmOLAPLxv input{height:32px;font-size:24px}.jnkSQuOXOUbFGhdbs7fU.NtCnQjNPcjARKl0A6MDM input{letter-spacing:-.24px;width:100%;height:40px;font-size:16px}.jnkSQuOXOUbFGhdbs7fU.ZKBWcfdbokzLspdMEheB input{height:24px;font-size:16px;font-style:normal;font-weight:500;line-height:150%}.jnkSQuOXOUbFGhdbs7fU.lBbaR5sbGGQW0HctmQ_x input{width:100%;height:16px;font-size:13px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `jnkSQuOXOUbFGhdbs7fU`,
	"large": `yzY6fzNfpUpkmOLAPLxv`,
	"medium": `NtCnQjNPcjARKl0A6MDM`,
	"lg-medium": `ZKBWcfdbokzLspdMEheB`,
	"lgMedium": `ZKBWcfdbokzLspdMEheB`,
	"small": `lBbaR5sbGGQW0HctmQ_x`
};
export default ___CSS_LOADER_EXPORT___;
